const v = (name: string, outputs: readonly { type: string; name?: string }[], inputs: readonly { type: string; name: string }[] = []) =>
  ({ type: 'function', name, stateMutability: 'view', inputs, outputs }) as const;

export const maplePoolAbi = [
  v('totalAssets', [{ type: 'uint256' }]), v('totalSupply', [{ type: 'uint256' }]),
  v('unrealizedLosses', [{ type: 'uint256' }]), v('manager', [{ type: 'address' }]),
  v('convertToAssets', [{ type: 'uint256' }], [{ name: 'shares', type: 'uint256' }]),
  v('balanceOf', [{ type: 'uint256' }], [{ name: 'account', type: 'address' }]),
] as const;

export const maplePoolManagerAbi = [
  v('liquidityCap', [{ type: 'uint256' }]), v('hasSufficientCover', [{ type: 'bool' }]),
  v('withdrawalManager', [{ type: 'address' }]), v('poolDelegate', [{ type: 'address' }]),
  v('strategyListLength', [{ type: 'uint256' }]), v('strategyList', [{ type: 'address' }], [{ name: 'i', type: 'uint256' }]),
] as const;

export const mapleWithdrawalManagerAbi = [
  v('queue', [{ name: 'nextRequestId', type: 'uint128' }, { name: 'lastRequestId', type: 'uint128' }]),
  v('totalShares', [{ type: 'uint256' }]),
] as const;

export const mapleLoanManagerAbi = [
  v('principalOut', [{ type: 'uint128' }]), v('assetsUnderManagement', [{ type: 'uint256' }]), v('unrealizedLosses', [{ type: 'uint128' }]),
] as const;
